import { PosterSize } from "../../common-types/poster-size";

export const getAvailableBildbyranPosterSizes = async (orientation: 'portrait' | 'landscape' | 'square') => {
    return (orientation == 'portrait' ? ['21x30', '30x40', '50x70', '70x100'] : ['30x21', '40x30', '70x50', '100x70']) as PosterSize[];
}